import { render, staticRenderFns } from "./uploadDialog.vue?vue&type=template&id=3a056b62&scoped=true&"
import script from "./uploadDialog.vue?vue&type=script&lang=js&"
export * from "./uploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./uploadDialog.vue?vue&type=style&index=0&id=3a056b62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a056b62",
  null
  
)

export default component.exports